import { Button } from '@schibsted-svp/react-ui';
import { useFormikContext } from 'formik';

import type { ComponentProps, FC, ReactNode } from 'react';

type Props = Omit<ComponentProps<typeof Button>, 'children' | 'type'> & {
  children?: ReactNode;
};

const SubmitButton: FC<Props> = ({ children, ...props }) => {
  const { isSubmitting = false } = useFormikContext();

  return (
    <Button type="submit" loading={isSubmitting} {...props}>
      {children}
    </Button>
  );
};

export { SubmitButton };
